import React, { useEffect, useState } from 'react';

import { CircularProgress, Grid, TextField } from '@material-ui/core';

import { Formik, Form } from 'formik';

import notification from 'app/config/notification';
import { VEHICLE_REPORT_SITUATION } from 'app/utils/constants';
import { inspectionReportValidationSchema } from 'app/utils/forms/validationsSchemas';
import { inspectionReportPayload } from 'app/utils/forms/payloadsStruture';
import SaveButton from '../SaveButton';

import VehicleData from './VehicleData/VehicleData';
import SurveyInfo from './SurveyInfo/SurveyInfo';
import Irregularities from './Irregularities/Irregularities';
import surveyEndpoint from 'app/api/services/surveyEndpoint';
import Files from './Files';
import { injectIntl } from 'react-intl';
import { searchCompanyNameAndDocument } from 'app/store/slices/company';

function SurveyForm(props) {
  const {
    intl,
    open,
    request,
    surveyVehicle,
    classes,
    onSave,
    onCancel,
    contextProps: { isInternalForm, canEdit, mainColor },
  } = props;

  const [loading, setLoading] = useState(false);
  const [loadingCompany, setLoadingCompany] = useState(false);
  const [loadingSituation, setLoadingSituation] = useState(false);

  const [vehicle] = useState(surveyVehicle.veiculo || {});
  const [changingDate, setChangingDate] = useState(0);
  const [irregularities, setIrregularities] = useState(() => {
    if (surveyVehicle?.irregularidades) return surveyVehicle?.irregularidades;
    return [];
  });
  const [companyName, setCompanyName] = useState('');
  const [situation, setSituation] = useState(() => {
    if (surveyVehicle.boVeiculoAusente) {
      return VEHICLE_REPORT_SITUATION.REPROVADO.description.toUpperCase();
    }
    if (surveyVehicle.tpSituacao) {
      const filtered = Object.entries(VEHICLE_REPORT_SITUATION).filter(
        sit => sit[1] && sit[1].sg === surveyVehicle.tpSituacao
      );
      if (filtered[0]) {
        return filtered[0][0] || '';
      }
    }
    return VEHICLE_REPORT_SITUATION.APROVADO.description.toUpperCase();
  });

  const [reportInitialValues] = useState(surveyVehicle || inspectionReportPayload);

  const onChangeDate = (field, value, setFieldValue) => {
    setChangingDate(changingDate + 1);
    setFieldValue(field, value);
  };

  useEffect(() => {
    const init = async () => {
      if (open) {
        setLoadingSituation(true);
        try {
          const search = irregularities.filter(irr => irr.defeito && irr.defeito?.pontuacaoDefeito != null);
          const response = await surveyEndpoint.getSurveyVehicleSituation(search);
          if (response.status === 200 && response.data) {
            setSituation(response.data);
          }
        } catch (error) {}
        setLoadingSituation(false);
      }
    };
    init();
  }, [open, irregularities]);

  useEffect(() => {
    const init = async () => {
      if (open && request?.jsonSolicitacao) {
        const jsonSolicitacao = JSON.parse(request.jsonSolicitacao);
        let tempName = jsonSolicitacao.cdTipoPessoaFisica
          ? jsonSolicitacao.nmCompleto || ''
          : jsonSolicitacao.deRazaoSocial ||
            jsonSolicitacao.nmCompleto ||
            jsonSolicitacao.nmUsuario ||
            '';

        if (tempName === '') {
          setLoadingCompany(true);
          const companyInfo = await searchCompanyNameAndDocument(request.cdSolicitacao);
          tempName = companyInfo.name;
          setLoadingCompany(false);
        }

        setCompanyName(tempName);
      }
    };
    init();
  }, [open, request]);

  const validateIrregularities = () => {
    let result = true;
    const temp = irregularities.map(irr => {
      if (!irr.cdClassificacaoDefeito) {
        irr.error = true;
        result = false;
      } else {
        if (irr.error) delete irr.error;
      }
      return irr;
    });
    setIrregularities(temp);
    return result;
  };

  const [reportValidationSchema] = useState(() => {
    return inspectionReportValidationSchema;
  });

  return (
    <>
      <Formik
        enableReinitialize={true}
        initialValues={reportInitialValues}
        validationSchema={reportValidationSchema}
        validateOnBlur={false}
        validateOnChange={false}
        onSubmit={() => {}}
      >
        {formProps => {
          const { values } = formProps;
          return (
            <Form className={classes.containerForm}>
              <Grid container spacing={3}>
                <Grid item xs={12} sm={6}>
                  {loadingCompany && <CircularProgress size={20} />}
                  {!loadingCompany && (
                    <TextField
                      name="cdEmpresa"
                      label={'Empresa/Nome'}
                      variant="filled"
                      margin="dense"
                      value={companyName}
                      disabled={true}
                      fullWidth
                      inputProps={{
                        maxLength: 90,
                      }}
                    />
                  )}
                </Grid>
              </Grid>
              <Grid container spacing={3}>
                <VehicleData
                  {...props}
                  {...formProps}
                  classes={classes}
                  vehicle={vehicle}
                  canEdit={canEdit}
                />
              </Grid>
              <Grid container spacing={3}>
                <Irregularities
                  {...props}
                  {...formProps}
                  canEdit={canEdit}
                  irregularities={irregularities}
                  setIrregularities={setIrregularities}
                  situation={situation}
                  setSituation={setSituation}
                />
              </Grid>
              <Grid container spacing={3}>
                <SurveyInfo
                  {...props}
                  {...formProps}
                  classes={classes}
                  canEdit={canEdit}
                  onChangeDate={onChangeDate}
                  loadingSituation={loadingSituation}
                  situation={situation}
                />
              </Grid>

              <Grid container spacing={3}>
                <Files {...props} {...formProps} />
              </Grid>

              <SaveButton
                mainColor={mainColor}
                hideActionBtn={!canEdit}
                isInternalForm={isInternalForm}
                canEdit={canEdit}
                sending={loading}
                onCancel={() => {
                  !!onCancel && onCancel(values);
                }}
                onSave={() => {
                  formProps.validateForm().then(async res => {
                    if (Object.keys(res).length <= 0) {
                      if (onSave) {
                        setLoading(true);
                        const validIrregularities = validateIrregularities();
                        if (!validIrregularities) {
                          notification(
                            intl.formatMessage({
                              id: 'MESSAGES.SERVICE.FORMS.IRREGULARITIES_ERROR',
                            }),
                            {
                              toastId: 'IRREGULARITIES_ERROR',
                              type: 'error',
                            }
                          );
                          setLoading(false);
                          return;
                        }

                        values.irregularidades = irregularities;
                        let status =
                          VEHICLE_REPORT_SITUATION[situation]?.sg ||
                          VEHICLE_REPORT_SITUATION.APROVADO.sg;

                        if (values.boVeiculoAusente) {
                          status = VEHICLE_REPORT_SITUATION.REPROVADO.sg;
                        }
                        values.tpSituacao = status;
                        try {
                          await onSave(values);
                        } catch (error) {}
                        setLoading(false);
                      }
                    } else {
                      notification('O(s) campo(s) sinalizado(s) precisam de revisão.', {
                        toastId: 'VALIDATION',
                        type: 'error',
                      });
                    }
                  });
                }}
              />
            </Form>
          );
        }}
      </Formik>
    </>
  );
}
export default injectIntl(SurveyForm);
